import { useLazyQuery as y } from "@apollo/client";
import { currencyInfoSchema as h } from "../../deserialize/yup/currency.js";
import b from "../../graphql/query/getCurrencyInfo.js";
import * as e from "ramda";
import { useState as g, useCallback as s } from "react";
const x = () => {
  const [a, { refetch: r }] = y(b), [c, n] = g(null), p = s(
    async (u) => {
      const f = await a({ variables: {
        name: u
      } }), d = e.pathOr(
        [],
        ["data", "getClaimableRewardTypeInfosByRewardName"],
        f
      ), i = e.map(
        (t) => h.cast(t),
        d
      ), l = e.groupBy(
        e.prop("type"),
        i
      ), o = e.mapObjIndexed(
        (t) => e.head(t),
        l
      );
      return n(o), o;
    },
    [a]
  ), m = s(async () => {
    r();
  }, [r]);
  return {
    data: c,
    fetch: p,
    refetch: m
  };
};
export {
  x as default
};
//# sourceMappingURL=useGetCurrencyInfo.js.map
